import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Card, CardBody, Col, Form, FormFeedback, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledTooltip } from 'reactstrap';
import Flatpickr from "react-flatpickr";
import * as Yup from "yup";
import { useFormik } from 'formik';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import miniral from "../../../assets/images/svg/miniral.svg";
import { numberWithCommas } from "../../../helpers/globalHelper"
import TableContainer from 'Components/Common/TableContainer';
import DeleteModal from 'Components/Common/DeleteModal';
import Spinners from "Components/Common/Spinner";

import ShapeUpload from 'Components/fileUpload/ShapeUpload';
import MainMap from "Components/MainMap/Index";
import voyager from '../../../assets/images/map/voyager.png';
import google from '../../../assets/images/map/google.jpg';
import topo from '../../../assets/images/map/topo.jpg';
import openstreet from '../../../assets/images/map/openstreet.jpg';

import { useNormalzoneCreateMutation, useNormalzoneDeleteMutation, useNormalzoneFindAllQuery, useNormalzoneUpdateMutation, useNormalzoneFindOneQuery } from 'store/apis/core/surfaceWater/normalzoneApi';
import { useAu1FindAllQuery, useCommonDataFindAllQuery, useDocumentCreateMutation, useDocumentFindAllQuery, useStatusFindAllQuery } from 'store';




const ZONE_COLORS = ['#01949A', '#E8590C', '#7048E8', '#2F9E44', '#C2255C', '#1971C2', '#F08C00'];

// geoms: [{ protection_type, geom }] -> FeatureCollection, төрөл бүр өөр өнгөтэй
const buildZoneFeatureCollection = (geoms: any[] | undefined, typeOrder: any[] | undefined) => {
  const features = (geoms || [])
    .filter((g: any) => g?.geom)
    .map((g: any) => {
      const idx = Math.max(0, (typeOrder || []).findIndex((t: any) => Number(t.id) === Number(g.protection_type)));
      return {
        type: 'Feature',
        properties: { protection_type: g.protection_type, color: ZONE_COLORS[idx % ZONE_COLORS.length] },
        geometry: g.geom,
      };
    });
  return features.length > 0 ? { type: 'FeatureCollection', features } : undefined;
};

const Detail = ({ searchField }: any) => {

  // Modal тай холбоотой
  const [modalViewBackdrop, setModalViewBackdrop] = useState(false)
  const [modal_backdrop, setModal_backdrop] = useState(false);
  const [isLoading, setLoading] = useState<any>(true);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<any>(null);

  //  Paginition 
  const [normalzoneCount, setNormalzoneCount] = useState<any>();
  const [normalzoneList, setNormalzoneList] = useState<any>();
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  // Дататай холбоотой state
  const [normalzoneUptOne, setNormalzoneUptOne] = useState<any>(null)
  const [normalzoneDataOne, setNormalzoneDataOne] = useState<any>(null)
  const [selectedNormalzoneId, setSelectedNormalzoneId] = useState<number | null>(null)
  const [au1Selected, setAu1Selected] = useState<string>('');
  const [customQuery, setCustomQuery] = useState<any>();

  //Shape file
  const [filesByType, setFilesByType] = useState<Record<string, File[]>>({})
  const [removedTypes, setRemovedTypes] = useState<number[]>([])
  // Нэмж буй шинэ бүсүүд (төрөл + shape файл)
  const [newZones, setNewZones] = useState<{ key: number; type: string; files: File[] }[]>([])
  const [selectedPdf, setSelectedPdf] = useState<File | null>(null)
  const [resetFiles, setResetFiles] = useState<any>([])
  const [baseMap, setBaseMap] = useState("voyager")
  const [customCenter, setCustomCenter] = useState<any>();

  // Api дуудах
  const [normalzoneCreate, normalzoneCreateResult] = useNormalzoneCreateMutation();
  const [normalzoneUpdate, normalzoneUpdateResult] = useNormalzoneUpdateMutation();
  const [normalzoneDelete, normalzoneDeleteResult] = useNormalzoneDeleteMutation();
  const [documentCreate] = useDocumentCreateMutation();

  const {
    data:
    findOnedata,
    error } = useNormalzoneFindOneQuery(selectedNormalzoneId, {
      skip: !selectedNormalzoneId,
      refetchOnMountOrArgChange: true,
    });

  const {
    data: au1Data,
    error: au1Error,
    isFetching: isAu2Fetching,
  } = useAu1FindAllQuery();

  const { data: decisionLevelData } = useCommonDataFindAllQuery('?group_name=decision_level');
  const { data: protectionTypeData } = useCommonDataFindAllQuery('?group_name=protection_type');
  const { data: statusData } = useStatusFindAllQuery();

  const typeNameById = (id: number) =>
    protectionTypeData?.data?.find((t: any) => Number(t.id) === Number(id))?.name || `#${id}`;

  // Аль хэдийн ашиглагдаж буй төрлүүд (бүртгэлтэй, устгаагүй + шинээр нэмсэн)
  const usedTypeIds: number[] = [
    ...(isEdit ? (normalzoneDataOne?.geoms || []) : [])
      .map((g: any) => Number(g.protection_type))
      .filter((id: number) => !removedTypes.includes(id)),
    ...newZones.filter((z) => z.type).map((z) => Number(z.type)),
  ];

  const zoneGeoJson = useMemo(
    () => buildZoneFeatureCollection(
      (normalzoneDataOne?.geoms || []).filter((g: any) => !removedTypes.includes(Number(g.protection_type))),
      protectionTypeData?.data
    ),
    [normalzoneDataOne?.geoms, removedTypes, protectionTypeData]
  );

  const { data: attachmentData } = useDocumentFindAllQuery(
    `?table_name=normal_zone&connection_id=${selectedNormalzoneId}&value_group=attachment`,
    { skip: !selectedNormalzoneId }
  );

  const {
    data: normalzoneData,
    error: normalzoneError,
    isFetching: isNormalzoneFetching,
  } = useNormalzoneFindAllQuery(customQuery);

  // UseEffect - үүд
  useEffect(() => {
    if (findOnedata?.data) {
      setNormalzoneDataOne(findOnedata.data)
      const firstGeom = (findOnedata.data as any)?.geoms?.find((g: any) => g?.geom);
      const tempCenter = { cusCenter: firstGeom?.geom?.coordinates?.[0]?.[0]?.[0] };
      setCustomCenter(tempCenter)
    }
  }, [findOnedata])

  useEffect(() => {
    setLoading(false)
    setNormalzoneList(normalzoneData?.data)
    setNormalzoneCount(normalzoneList?.length)
    setCustomPagination(normalzoneData?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField || ''}`;
    setCustomQuery(tempQuery)

  }, [normalzoneData, customPageLength, customPageSize, searchField])

  // Цонх modal хаагдах 
  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }
  function modal_view_backdrop() {
    setModalViewBackdrop(!modalViewBackdrop);
    removeBodyCss();
  }
  // toggle дахин үүсэхээс сэргийлэх cache цэвэрлэх
  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setModal_backdrop(false);
    } else {
      setModal_backdrop(true);
    }
  }, [modal_backdrop]);

  // OnClick-үүд
  // Дата нэмэх цонх нээх товч
  const handleAddClick = () => {
    setNormalzoneDataOne(null);
    setNormalzoneUptOne(null);
    setSelectedNormalzoneId(null);
    setCustomCenter(undefined);
    setSelectedPdf(null);
    setFilesByType({});
    setRemovedTypes([]);
    setNewZones([]);
    setIsEdit(false);
    toggle();
  };
  // Дата устгах цонх нээх товч
  const handleDeleteClick = (normalzoneRowData) => {
    setNormalzoneDataOne(normalzoneRowData);
    setDeleteModal(true);
  };
  // delete data button
  const handleDeleteClickData = () => {
    if (normalzoneDataOne) {
      normalzoneDelete(normalzoneDataOne.id);
      // close the delete modal
      setDeleteModal(false);
    }
  }
  // Дата засах товч
  const handleEditClick = useCallback((arg: any) => {
    const normalzoneTemp = arg;
    setNormalzoneDataOne(normalzoneTemp);
    setSelectedNormalzoneId(normalzoneTemp.id);
    setCustomCenter(undefined);
    setNormalzoneUptOne({
      id: normalzoneTemp.id,
      name: normalzoneTemp.name,
      au1_code: normalzoneTemp.au1_code,
      decision_date: normalzoneTemp.decision_date,
      decision_no: normalzoneTemp.decision_no,
      decision_level: normalzoneTemp.decision_level,
      date: normalzoneTemp.date,
      status: normalzoneTemp.status,
    });
    setFilesByType({});
    setRemovedTypes([]);
    setNewZones([]);
    setIsEdit(true);
    toggle();
  }, []);

  // Дата харах товч
  const handleViewClick = (normalzoneRowData) => {
    setNormalzoneDataOne(normalzoneRowData);
    setSelectedNormalzoneId(normalzoneRowData.id);
    modal_view_backdrop();
  };
  // Батлах товч
  const handleConfirmClick = useCallback((arg: any) => {
    const approvedStatus = statusData?.data?.find((item: any) => item.code === 'approved');
    if (!approvedStatus) {
      toastr.error("Батлагдсан төлөв олдсонгүй!", "Амжилтгүй");
      return;
    }
    const formData = new FormData();
    formData.append('id', arg ? arg.id.toString() : '0');
    formData.append('status_id', String(approvedStatus.id));
    normalzoneUpdate(formData)
      .unwrap()
      .then((response) => {
        toastr.success("Ажилттай батлагдлаа!", "Амжилттай");
      })
      .catch((error) => {
        toastr.error("Амжилтгүй!", "Амжилтгүй");
      })
  }, [normalzoneUpdate, statusData]);

  // Хүчингүй товч
  const handleCancelClick = useCallback((arg: any) => {
    const rejectedStatus = statusData?.data?.find((item: any) => item.code === 'rejected');
    if (!rejectedStatus) {
      toastr.error("Цуцлагдсан төлөв олдсонгүй!", "Амжилтгүй");
      return;
    }
    const formData = new FormData();
    formData.append('id', arg ? arg.id.toString() : '0');
    formData.append('status_id', String(rejectedStatus.id));
    normalzoneUpdate(formData)
      .unwrap()
      .then((response) => {
        toastr.success("Хүчингүй боллоо!", "Амжилттай");
      })
      .catch((error) => {
        toastr.error("Амжилтгүй!", "Амжилтгүй");
      })
  }, [normalzoneUpdate, statusData]);

  // Formik
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: normalzoneDataOne?.id,
      name: normalzoneDataOne?.name,
      au1_code: normalzoneDataOne?.au1_code,
      decision_date: normalzoneDataOne?.decision_date,
      decision_no: normalzoneDataOne?.decision_no,
      decision_level: normalzoneDataOne?.decision_level,
      date: normalzoneDataOne?.date,
      status: normalzoneDataOne?.status,
    },
    validationSchema: Yup.object({
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу !").required("Утга оруулна уу"),
    }),

    onSubmit: async (values: any) => {
      const formData = new FormData();
      if (isEdit) formData.append('id', normalzoneUptOne ? normalzoneUptOne.id.toString() : '0');
      formData.append('name', values?.name || '');
      formData.append('au1_code', values?.au1_code || '');
      formData.append('decision_date', values?.decision_date || '');
      formData.append('decision_no', values?.decision_no || '');
      if (values?.decision_level) formData.append('decision_level', values.decision_level);
      formData.append('date', values?.date || '');

      if (newZones.some((z) => !z.type || z.files.length === 0)) {
        toastr.error("Нэмсэн бүс бүрт төрөл сонгож, shape файл оруулна уу!", "Амжилтгүй");
        return;
      }
      Object.entries(filesByType).forEach(([typeId, files]) => {
        files?.forEach((file: File) => formData.append(`shapes_${typeId}`, file));
      });
      newZones.forEach((z) => z.files.forEach((file: File) => formData.append(`shapes_${z.type}`, file)));
      if (removedTypes.length > 0) formData.append('remove_protection_types', removedTypes.join(','));

      try {
        const response: any = isEdit
          ? await normalzoneUpdate(formData).unwrap()
          : await normalzoneCreate(formData).unwrap();
        const recordId = normalzoneUptOne?.id || response?.data?.id;

        if (selectedPdf && recordId) {
          const documentData = new FormData();
          documentData.append('table_name', 'normal_zone');
          documentData.append('connection_id', String(recordId));
          documentData.append('value_group', 'attachment');
          documentData.append('files', selectedPdf);
          await documentCreate(documentData).unwrap();
        }

        toastr.success(isEdit ? "Мэдээлэл амжилттай засагдлаа!" : "Мэдээлэл амжилттай үүслээ!", "Амжилттай");
        validation.resetForm();
        setSelectedPdf(null);
        setFilesByType({});
        setRemovedTypes([]);
        setNewZones([]);
        setModal_backdrop(false);
      } catch (error: any) {
        toastr.error(error?.data?.error || error?.data || "Мэдээлэл амжилтгүй!", "Амжилтгүй");
      }
    }
  });

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Аймаг/Нийслэл',
        accessorKey: "au1_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'ИТХ-ын тогтоолын огноо',
        accessorKey: "decision_date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'ИТХ-ын тогтоолын дугаар',
        accessorKey: "decision_no",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Хамгаалалтын төрөл',
        accessorKey: "geoms",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          const names = (cellProps.row.original.geoms || [])
            .map((g: any) => protectionTypeData?.data?.find((t: any) => Number(t.id) === Number(g.protection_type))?.name)
            .filter(Boolean);
          return <span>{names.length ? names.join(', ') : '-'}</span>;
        }
      },
      {
        header: 'Огноо',
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Төлөв',
        accessorKey: "status.name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => <span className="fw-semibold fs-6 px-2 py-1 rounded-pill text-info">{cellProps.row.original.status?.name || "-"}</span>
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-primary"
                  onClick={(event: any) => {
                    const normalzoneData = cellProps.row.original;
                    event.preventDefault();
                    handleViewClick(normalzoneData);
                  }}
                >
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                  <UncontrolledTooltip placement="top" target="viewtooltip">
                    Харах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <Link
                to="#"
                className="btn btn-sm btn-soft-warning"
                onClick={(event: any) => {
                  const normalzoneData = cellProps.row.original;
                  event.preventDefault();
                  handleEditClick(normalzoneData);
                }}
              >
                <i className="mdi mdi-pencil-outline" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Засах
                </UncontrolledTooltip>
              </Link>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const normalzoneRowData = cellProps.row.original;
                    event.preventDefault();
                    handleDeleteClick(normalzoneRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-success"
                  onClick={(event: any) => {
                    const normalzoneRowData = cellProps.row.original;
                    event.preventDefault();
                    handleConfirmClick(normalzoneRowData);
                  }}
                >
                  <i className="mdi mdi-checkbox-marked-circle-outline" id="confirmtooltip" />
                  <UncontrolledTooltip placement="top" target="confirmtooltip">
                    Батлах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  style={{ color: "red" }}
                  onClick={(event: any) => {
                    const normalzoneRowData = cellProps.row.original;
                    event.preventDefault();
                    handleCancelClick(normalzoneRowData);
                  }}
                >
                  <i className="mdi mdi-close-circle-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Хүчингүй
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        }
      },
    ],
    [handleEditClick, handleConfirmClick, handleCancelClick, protectionTypeData]
  );

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={normalzoneDataOne?.normalzone_name}
        show={deleteModal}
        onDeleteClick={handleDeleteClickData}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={miniral} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibol
                    ">Нийт: {numberWithCommas(1644)}</span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  handleAddClick();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
              </button>
            </div>
          </CardBody>
          <CardBody>
            {
              isLoading ? <Spinners setLoading={setLoading} />
                :
                <TableContainer
                  setCustomPageSize={setCustomPageSize}
                  setCustomPageLength={setCustomPageLength}
                  customPagination={customPagination}
                  columns={columns}
                  data={normalzoneList || ""}
                  isCustomPageSize={true}
                  isGlobalFilter={true}
                  isPagination={true}
                  colWidth={3}
                  SearchPlaceholder="Хамгаалалтын газар хайх . . ."
                  tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                  pagination="pagination"
                  paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                />
            }
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={'static'}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          toggle();
        }}>
          <div className="h5 modal-title" id="staticBackdropLabel">{!!isEdit ? "Усны хориглолт, хамгаалалтын бүс засах" : "Усны хориглолт, хамгаалалтын бүс нэмэх"}</div>
        </ModalHeader>
        <ModalBody>
          <Alert color="warning" className="mb-3">
            <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
            <Link to="#" className="alert-link">
              заавал бөглөх
            </Link>  шаардлагатайг анхаарна уу !!!
          </Alert>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>Нэр</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name &&
                        validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name &&
                    validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Аймаг/Нийслэл</Label>
                  <Input
                    name="au1_code"
                    type="select"
                    onChange={(e) => {
                      validation.handleChange(e);
                      setAu1Selected(e.target.value);
                    }}
                    onBlur={validation.handleBlur}
                    value={
                      validation.values.au1_code || ""
                    }
                    invalid={
                      validation.touched.au1_code && validation.errors.au1_code ? true : false
                    }

                  >
                    <option disabled value="">Сонгох</option>
                    {au1Data?.data?.map((item, index) => (
                      <option value={item?.code}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.au1_code &&
                    validation.errors.au1_code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.au1_code}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label> ИТХ-ын тогтоолын огноо</Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder=" ИТХ-ын тогтоолын огноо"
                    name="decision_date"
                    value={validation.values.decision_date}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('decision_date', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                  {validation.touched.decision_date &&
                    validation.errors.decision_date ? (
                    <FormFeedback type="invalid">
                      {validation.errors.decision_date}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>ИТХ-ын тогтоолын дугаар
                  </Label>
                  <Input
                    name="decision_no"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.decision_no || ""}
                    invalid={
                      validation.touched.decision_no &&
                        validation.errors.decision_no
                        ? true
                        : false
                    }
                  />
                  {validation.touched.decision_no &&
                    validation.errors.decision_no ? (
                    <FormFeedback type="invalid">
                      {validation.errors.decision_no}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Тогтоолын түвшин</Label>
                  <Input
                    name="decision_level"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.decision_level || ""}
                  >
                    <option value="">Сонгох</option>
                    {decisionLevelData?.data?.map((item) => (
                      <option key={item.id} value={item.id}>{item.name}</option>
                    ))}
                  </Input>
                </div>
                <div className="mb-3">
                  <Label>Огноо</Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="date"
                    value={validation.values.date}
                    onChange={(selectDate: Date[]) => {
                      if (selectDate[0]) {
                        const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                          .toISOString()
                          .split('T')[0];
                        validation.setFieldValue('date', localDate);
                      }
                    }}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                  {validation.touched.date &&
                    validation.errors.date ? (
                    <FormFeedback type="invalid">
                      {validation.errors.date}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label>Хавсралт PDF оруулах</Label>
                  <Input
                    type="file"
                    accept="application/pdf,.pdf"
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      setSelectedPdf(event.target.files?.[0] || null);
                    }}
                  />
                  {selectedPdf && <small className="text-muted">{selectedPdf.name}</small>}
                  {isEdit && attachmentData?.data
                    ?.filter((item: any) => item?.type_name === 'pdf')
                    ?.map((item: any, index: number) => (
                      <div className="mt-2" key={item.id || index}>
                        <Link
                          to={item.fileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-danger btn-label"
                        >
                          <i className="mdi mdi-file-pdf-outline label-icon" />
                          Хавсралт PDF {index + 1}
                        </Link>
                      </div>
                    ))}
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col lg={5}>
                <div className="d-flex align-items-center mb-2">
                  <h6 className="mb-0">Хамгаалалтын бүсүүд</h6>
                  <button
                    type="button"
                    className="btn btn-sm btn-success ms-auto"
                    disabled={usedTypeIds.length >= (protectionTypeData?.data?.length || 0)}
                    onClick={() => setNewZones((prev) => [...prev, { key: Date.now() + prev.length, type: '', files: [] }])}
                  >
                    <i className="mdi mdi-plus me-1" />Бүс нэмэх
                  </button>
                </div>

                <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                  {!(isEdit && (normalzoneDataOne?.geoms || []).length) && newZones.length === 0 && (
                    <small className="text-muted">Бүс нэмээгүй байна. "Бүс нэмэх" товчийг дарна уу.</small>
                  )}

                  {isEdit && (normalzoneDataOne?.geoms || []).filter((g: any) => g?.protection_type != null).map((g: any) => {
                    const typeId = Number(g.protection_type);
                    const removed = removedTypes.includes(typeId);
                    const idx = (protectionTypeData?.data || []).findIndex((t: any) => Number(t.id) === typeId);
                    return (
                      <div key={`existing-${typeId}`} className="border rounded p-2 mb-2">
                        <div className="d-flex align-items-center">
                          <span className="rounded-circle d-inline-block me-2" style={{ width: 10, height: 10, background: ZONE_COLORS[Math.max(idx, 0) % ZONE_COLORS.length] }} />
                          <span className={`fw-semibold ${removed ? 'text-decoration-line-through text-muted' : ''}`}>{typeNameById(typeId)}</span>
                          <button
                            type="button"
                            className={`btn btn-sm py-0 ms-auto ${removed ? 'btn-soft-secondary' : 'btn-soft-danger'}`}
                            onClick={() => setRemovedTypes((prev) => removed ? prev.filter((id) => id !== typeId) : [...prev, typeId])}
                          >
                            {removed ? 'Буцаах' : 'Устгах'}
                          </button>
                        </div>
                        {!removed && (
                          <div className="mt-1">
                            <ShapeUpload
                              compact
                              label="Файлаар солих"
                              selectFiles={(files: File[]) => setFilesByType((prev) => ({ ...prev, [typeId]: files }))}
                              onReset={resetFiles}
                              onResetValueChange={setResetFiles}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {newZones.map((zone) => {
                    const options = (protectionTypeData?.data || []).filter(
                      (t: any) => String(t.id) === zone.type || !usedTypeIds.includes(Number(t.id))
                    );
                    return (
                      <div key={zone.key} className="border rounded p-2 mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <Input
                            type="select"
                            bsSize="sm"
                            className="form-select"
                            value={zone.type}
                            onChange={(e) => {
                              const value = e.target.value;
                              setNewZones((prev) => prev.map((z) => z.key === zone.key ? { ...z, type: value } : z));
                            }}
                          >
                            <option value="">Төрөл сонгох</option>
                            {options.map((t: any) => <option key={t.id} value={t.id}>{t.name}</option>)}
                          </Input>
                          <button
                            type="button"
                            className="btn btn-sm btn-soft-danger py-0"
                            onClick={() => setNewZones((prev) => prev.filter((z) => z.key !== zone.key))}
                          >
                            <i className="mdi mdi-delete-outline" />
                          </button>
                        </div>
                        <div className="mt-1">
                          <ShapeUpload
                            compact
                            selectFiles={(files: File[]) =>
                              setNewZones((prev) => prev.map((z) => z.key === zone.key ? { ...z, files } : z))}
                            onReset={resetFiles}
                            onResetValueChange={setResetFiles}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Col>
              <Col lg={7}>
                <div className='mapTypeSelection'>
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                  <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                </div>
                <MainMap
                  baseMap={baseMap}
                  results={zoneGeoJson}
                  customCenter={customCenter}
                  customHeight="420px"
                  zoomChange={zoneGeoJson ? 10 : 6}
                />
              </Col>
            </Row>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">Хадгалах</button>
              <button type="button" className="btn btn-light" onClick={() => {
                setModal_backdrop(false);
              }}>Хаах</button>

            </div>
          </Form>

        </ModalBody>
      </Modal>

      <Modal
        size="xl"
        isOpen={modalViewBackdrop}
        toggle={() => {
          setModal_backdrop(true);
        }}
        id="staticBackdrop"
        centered
      >
        <ModalHeader toggle={() => {
          modal_view_backdrop();
        }}>
          <div className='h5 modal-title' id="staticBackdropLabel">Усны хориглолт, хамгаалалтын бүс</div>
        </ModalHeader>
        <Form onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}>
          <ModalBody>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>Нэр </Label>
                  <Input
                    name="name"
                    type="text"

                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={normalzoneDataOne?.name}
                  />
                </div>

                <div className="mb-3">
                  <label className='fw-semibold' >Аймаг/Нийслэлийн нэр:</label>
                  <div >
                    <Input
                      name="au1_name"
                      type="text"
                      disabled
                      onChange={validation.handleChange}
                      value={normalzoneDataOne?.au1_name}
                    >
                    </Input>
                  </div>
                </div>

              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <Label>ИТХ-ын тогтоолын огноо </Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="decision_date"
                    disabled
                    value={validation.values.decision_date}
                    onChange={validation.handleChange}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />
                </div>
                <div className="mb-3">
                  <Label>ИТХ-ын тогтоолын дугаар </Label>
                  <Input
                    name="number"
                    type="text"
                    disabled
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={normalzoneDataOne?.decision_no}
                  />
                </div>
                <div className="mb-3">
                  <Label>Тогтоолын түвшин</Label>
                  <Input type="text" disabled value={decisionLevelData?.data?.find((item) => Number(item.id) === Number(normalzoneDataOne?.decision_level))?.name || ""} />
                </div>
                <div className="mb-3">
                  <Label>Огноо </Label>
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Огноо"
                    name="date"
                    disabled
                    value={validation.values.date}
                    onChange={validation.handleChange}
                    options={{
                      altInput: true,
                      altFormat: "Y-m-d",
                      dateFormat: "Y-m-d",
                      enableTime: false,
                    }}
                  />

                </div>

              </Col>
            </Row>
            {zoneGeoJson ? (
              <Row>
                <Col lg={12}>
                  <div className='mapTypeSelection'>
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('voyager') }} src={voyager} alt="" />
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('google') }} src={google} alt="" />
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('topo') }} src={topo} alt="" />
                    <img style={{ cursor: 'pointer' }} onClick={() => { setBaseMap('openstreet') }} src={openstreet} alt="" />
                  </div>
                  <MainMap baseMap={baseMap} results={zoneGeoJson} customCenter={customCenter} zoomChange={10} />
                </Col>
              </Row>) : null}
          </ModalBody>
        </Form>
        <Col lg={5}>

        </Col>


      </Modal>
    </React.Fragment>
  );
}



export default Detail;
